// extracted by mini-css-extract-plugin
export default {"post":"PostCards_post__YBqt9","capa":"PostCards_capa__PXbKM","titulo":"PostCards_titulo__tzqPG"};